/* eslint-disable react/no-unused-prop-types */
import React, { useState } from 'react';
import { Select as MUISelect, FormControl, MenuItem, styled, SelectChangeEvent } from '@mui/material';
import TextField from '../TextField/TextField';

const StyledSelect = styled(MUISelect)(() => ({
  fontSize: '12px',
  cursor: 'pointer',
  userSelect: 'none',
  padding: '6px 10px',
  color: '#787878',
  ' .MuiSelect-select.MuiSelect-standard.MuiInputBase-input': {
    padding: '0px',
  },
  // ' svg': {
  //   position: 'static',
  // },
}));

type OptionValue = string | number;

type Option<T extends OptionValue> = {
  value: T;
  label: string;
};

interface IProps<TVal extends OptionValue> {
  title?: string;
  selectedOption?: TVal | string;
  setSelectedOption?: (selectedOption: TVal) => void;
  options: Option<TVal>[];
  width?: string;
  height?: string;
  selectDefault?: boolean;
}

const TitledSelect = <T extends OptionValue>({
  title,
  selectedOption,
  setSelectedOption,
  options,
  width,
  height,
}: IProps<T>) => {
  const [selectedValue, setSelectedValue] = useState<T | 'none'>('none');
  return (
    <FormControl sx={{ width: width ?? '100%' }} variant="standard">
      <StyledSelect
        input={<TextField height={height} />}
        defaultValue="none"
        value={setSelectedOption ? selectedOption ?? 'none' : selectedValue}
        onChange={(event) =>
          setSelectedOption ? setSelectedOption(event.target.value as T) : setSelectedValue(event.target.value as T)
        }
      >
        <MenuItem value="none" sx={{ display: 'none' }}>
          {title}
        </MenuItem>
        {options.map(({ value, label }) => (
          <MenuItem value={value} key={label}>
            {label}
          </MenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
};

const Select = <T extends OptionValue>(props: IProps<T>) => {
  const { title, options, width, height, setSelectedOption, selectDefault = true } = props;
  if (title) return <TitledSelect<T> {...props} />;
  return (
    // <FormControl sx={{ width: width ?? '100%' }} variant="standard">
    <StyledSelect
      onChange={(event) => setSelectedOption?.(event.target.value as T)}
      input={<TextField height={height} />}
      defaultValue={selectDefault && options[0]?.value}
    >
      {options.map(({ value, label }) => (
        <MenuItem value={value} key={value}>
          {label}
        </MenuItem>
      ))}
    </StyledSelect>
    // </FormControl>
  );
};

export default Select;
